import { BasicSelect } from 'vue-search-select'
import { Validator } from 'vee-validate'


export default {
	name: 'Minimum-Charges',
	components: {
		BasicSelect
	},
	props: ['rateTemplateDetailsObject'],
	data() {
		return {
		    minimumchargetype:null ,
        minimumcharges :null,
			  type: null,
        labelofA: null
		}
	},
	computed: {},
	mounted() {

	},
	methods: {
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

		setValues(rateTemplateDetailsObject) {
			if (rateTemplateDetailsObject) {
				this.minimumchargetype = (rateTemplateDetailsObject.minimumchargetype==1)?"BasicFreight":"NetCharges";
				this.minimumcharges = rateTemplateDetailsObject.minimumcharges
			}
      if(rateTemplateDetailsObject.minimumchargetype==1){
        this.labelofA = "A = Base Rate x Applicable Weight or Number of boxes"
      }
      else{
        this.labelofA = "A = Net charges"
      }
		},
		saveOnTabChange(){
			this.saveMinimumCharges("saveAndNext", true)
		},
		saveMinimumCharges(type, isTabChange ) {
      this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
  			this.type = type;
  			let submitobject = {
  				minimumchargetype: (this.minimumchargetype=="BasicFreight")?1:2,
  				minimumcharges: this.minimumcharges || null
  			}

  			if (type == "saveAndNext") {
  				if(isTabChange){
  					submitobject.isTabChange = isTabChange
  				}
  				this.$emit("saveandnext", submitobject)
  			} else {
  				this.$emit("save", submitobject)
  			}
      })
		},
    onMinimumchargetypeChange(){
      if(this.minimumchargetype=="BasicFreight"){
        this.labelofA = "A = Base Rate x Applicable Weight or Number of boxes"
      }
      else{
        this.labelofA = "A = Net charges"
      }
				this.minimumcharges=null
    }
	}
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/ratetemplate/createratetemplate/minimumcharges/minimumcharges.component.js